import React, { ReactNode, useEffect, useState } from 'react';
import { MeasurementHintTooltip } from 'common/components/measurement-hint/measurement-hint-tooltip';
import { actionButtonsWrapper } from 'common/components/product-card/styles';
import { QtyCounter } from 'common/components/qty-counter/qty-counter';
import { qtyInput } from './common-styles';
import { ProductType } from 'common/components/product-card/types';
import { WishlistButton } from './wishlist-button';
import { patchUrlByLocale } from 'utils';
import { ProductSetButton } from './product-set-button';
import { addTrailingSlash } from 'utils/url';
import { getPathname } from 'common/selectors/location';
import { useSelector } from 'react-redux';

type ProductActionButtonsProps = {
  showMeasurementTip: boolean;
  setShowMeasurementTip: React.Dispatch<React.SetStateAction<boolean>>;
  qty?: number;
  product: ProductType;
  inBasket: boolean;
  inShoppingList?: boolean;
  onShoppingListToggle?: (nextInShoppingList: boolean) => void;
  handleRemove: () => void;
  handleUpdate: (val: number) => void;
  isSet?: boolean;
  children: ReactNode;
};

export const ProductActionButtons: React.FC<ProductActionButtonsProps> = ({
  product,
  qty,
  inBasket,
  showMeasurementTip,
  setShowMeasurementTip,
  inShoppingList,
  onShoppingListToggle,
  handleRemove,
  handleUpdate,
  isSet,
  children,
}) => {
  const productLink = addTrailingSlash(product.productLink);
  const pathname = useSelector(getPathname);

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isHovered) {
      setShowMeasurementTip(false);
    }
  }, [isHovered, setShowMeasurementTip]);

  const handleMouseEvents = {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  };

  return (
    <MeasurementHintTooltip
      open={showMeasurementTip}
      placement="top"
      qty={qty}
      price={product.price}
      measurementData={product.measurementData}
    >
      <div className={actionButtonsWrapper} {...handleMouseEvents}>
        {isSet ? (
          <ProductSetButton href={patchUrlByLocale(productLink, pathname)} />
        ) : (
          <>
            {inBasket ? (
              <QtyCounter
                uom={
                  product.price.additional_as_main
                    ? product.price.additional_uom_rus
                    : product.price.main_uom_rus
                }
                step={product.price.step}
                min={product.price.step}
                overriddenValue={qty}
                className={qtyInput}
                onChange={(val) => handleUpdate(val)}
                onRemove={handleRemove}
              />
            ) : (
              children
            )}
          </>
        )}

        {onShoppingListToggle && !isSet && (
          <WishlistButton
            productId={product.productId || ''}
            size="l"
            inShoppingList={Boolean(inShoppingList)}
            onShoppingListToggle={onShoppingListToggle}
          />
        )}
      </div>
    </MeasurementHintTooltip>
  );
};
